// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ascii-char[data-v-22485153]{font:10px courier;stroke:none}.type-cursor[data-v-22485153]{fill:#00ff29}.typed[data-v-22485153]{stroke:#00ff29}", ""]);
// Exports
module.exports = exports;
